import svgLogo from "../assets/images/landing/logo.svg";
import svgNaverblog from "../assets/images/landing/naverblog.svg";
import { logout } from "../api/auth";
import { SessionStorageUtil } from "../utils/session_storage_util";

import "../assets/css/news.scss";

/**
 * 뉴스/서브 페이지용 Footer (CTA 섹션 없음)
 * - variant="light": #f7f9fc 배경 (구독 등)
 * - variant="white": 흰 배경 (키즈다 소식)
 * - variant="dark": 다크 배경
 */
function NewsFooter({ variant = "light" }) {
  const isLoggedIn = !!SessionStorageUtil.getItem("accessToken");

  const handleLogout = async () => {
    await logout();
    window.location.href = "/login";
  };

  return (
    <footer className={`news-footer ${variant === "light" ? "footer-light" : variant === "white" ? "footer-white" : ""}`}>
      <div className="news-container">
        {/* 회사 정보 + 링크 */}
        <div className="footer-mid">
          <div className="footer-info">
            <div className="footer-logo">
              <img
                src={svgLogo}
                alt="키즈다"
                className="logo-svg logo-svg-white"
              />
            </div>
            <div className="footer-details">
              <p>
                <strong>(주)위고컴퍼니</strong> | 대표:{" "}
                <strong>김영기</strong> | 사업자번호:{" "}
                <strong>339-87-00990</strong>
              </p>
              <p>
                경기도 화성시 동탄대로5길 21 4층 E420-A26호 (송동, 라크몽)
                <br />
                대표전화: 02-3288-3455 | 청소년보호책임자: 김준영
              </p>
              <p>통신판매업등록번호: 2021-화성동탄-0946 | 제호: 키즈다</p>
            </div>
          </div>

          <div className="footer-links-group">
            <div className="footer-col">
              <a href="/">서비스 소개</a>
              <a href="/news">키즈다 소식</a>
              <a href="/product">구독</a>
              <a href="/educlip">에듀클립</a>
            </div>
            <div className="footer-col">
              <a href="/application/service" target="_blank" rel="noreferrer">
                이용약관
              </a>
              <a href="/application/privacy" target="_blank" rel="noreferrer">
                개인정보처리방침
              </a>
              {isLoggedIn && (
                <button onClick={handleLogout} className="footer-logout-btn">
                  로그아웃
                </button>
              )}
            </div>
          </div>
        </div>

        {/* 하단: 저작권 */}
        <div className="footer-bottom">
          <p className="copyright">
            &copy; 2026 Kidsda Inc. All rights reserved.
          </p>
          <div className="social-links">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://blog.naver.com"
              target="_blank"
              rel="noreferrer"
              className="blog-icon"
              aria-label="네이버 블로그"
            >
              <img src={svgNaverblog} alt="네이버 블로그" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default NewsFooter;
